import { timeDefaultMs } from '@ardoq/design-tokens';
import styled, { css } from 'styled-components';

const fullScreenCSS = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const backdropCSS = css`
  ${fullScreenCSS};
  user-select: none;
  background-color: rgba(0, 0, 0, 0.2);
`;

export const DarkBackdropContent = styled.div`
  ${backdropCSS};
`;

export const FullscreenDiv = styled.div<{ $isDrawer?: boolean }>`
  ${fullScreenCSS};
  z-index: 1;
  ${({ $isDrawer }) => $isDrawer && 'align-items:flex-end'};
`;

export const ModalBackdrop = styled.div<{ $isVisible?: boolean }>`
  ${backdropCSS};

  /* ANIMATION */
  transition: opacity ${timeDefaultMs};
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
`;

export const ModalContentContainer = styled.div<{ $isVisible: boolean }>`
  z-index: 1;
  pointer-events: auto;
  &:focus {
    outline: none;
  }

  /* ANIMATION */
  transition:
    opacity ${timeDefaultMs},
    transform ${timeDefaultMs};
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  transform: ${({ $isVisible }) => `translateY(${$isVisible ? 0 : '-50px'})}`};
`;
